<template>
  <div :class="['file-player-component', fullscreenVal ? 'is-full-screen' : '']">
    <!-- <div class="player-component"> -->
    <div
      id="livePlayer"
      ref="livePlayer"
      v-show="!iconStatus && livePlayerShow"
      @touchstart="touchstartHandle('livePlayer', $event)"
      @touchmove="touchmoveHandle('livePlayer', $event)"
    ></div>
    <div
      id="drawPanel"
      v-show="liveStatus === 1 && onLine"
      :class="[iconStatus ? 'fullDrawPanel' : '']"
    ></div>
    <div class="overLive" v-show="liveStatus === 2 || liveStatus === 0 || !onLine">
      {{ liveStatus === 2 ? '直播已结束' : liveStatus === 0 ? '老师正在向你奔来 稍等一下下哦' : '请检查网络状态' }}
    </div>
    <div class="video-control">
      <!-- <template > -->
      <template v-if="controlShow && liveStatus === 1">
        <div class="control-top">
          <div class="left">
            <img
              src="../../../assets/img/live/back.png"
              alt=""
              @click="back"
              class="control-icon"
            />
            <span class="live-title">{{ $route.query.liveName }}</span>
          </div>
          <div class="right" v-if="fullscreenVal">
            <div class="set" @click="openLiveSet"></div>
          </div>
        </div>
        <div class="control-bottom">
          <div class="control-bottom-left" v-show="liveStatus === 1">
            <div @click="playPause">
              <!-- <template v-if="videoPlaying">
                <img src="../../../assets/img/live/end.png" alt="" class="control-icon">
              </template> -->
              <!-- <template v-else> -->
              <img
                v-if="!videoPlaying"
                src="../../../assets/img/live/start.png"
                alt=""
                class="control-icon"
              />
              <!-- </template> -->
            </div>
            <div v-if="playTime">已开课：{{ playTime }}</div>
            <div v-if="userCount && fullscreenVal && userCountShow" class="userCount">
              {{ userCount }} 在线
            </div>
          </div>
          <div class="control-bottom-right">
            <img @click="fullScreenClick" :src="fullscreenVal ? narrow : enlarge" alt="" />
            <img
              v-if="fullscreenVal"
              @click="changeChatNoticeStatus"
              :src="iconStatus ? putAway : open"
              alt="control-icon"
            />
          </div>
        </div>
      </template>
    </div>
    <Lottry :fullscreenVal="fullscreenVal" @fullScreenClick="fullScreenClick" />
    <Sign />
    <!-- 答题卡 -->
    <Answer />
    <LiveSet :liveId="liveData.liveId" v-if="showLiveSet" @closeLiveSet="closeLiveSet" />

  </div>
</template>
<script>
// eslint-disable-next-line import/extensions
import Lottry from './lottry';
// eslint-disable-next-line import/extensions
import Sign from './sign';
import { sendUploadStudyProgress } from '@/api/live';
import { mapState } from 'vuex';
import moment from 'moment';
import { timerCount } from '../../../utils/tools';
import Answer from './answer.vue';
import LiveSet from './liveSet.vue';


export default {
  props: {
    initData: {
      type: Object,
      default: () => {},
    },
    buyInfo: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    videoPlaying(val) {
      if (val) {
        // console.log('我开始直播了')
        this.isLiveStart = true;
        this.studyStartTime = moment();
        this.studyTime = 0;
        this.lastReportTime = 0;
        this.reportTime = 0;
        this.firstReport = true;
        window.clearInterval(this.uploadTimer);
        this.sendUploadStudyProgressFun(this.liveData, 1);
      }
    },
  },
  computed: {
    ...mapState(['userInfo']),
  },
  data() {
    return {
      loadCC: true,
      liveStatus: 0, // 0未直播，1直播中，2直播结束
      onLine: true, //true 连网 false 断网
      source_type: '', //摄像头状态
      fullscreenVal: false,
      controlShow: true,
      controlTimer: null,
      videoPlaying: false,
      studyStartTime: 0, // 学习开始
      studyTime: 0, // 学习时长
      reportTime: 0, // 本次上报时间
      lastReportTime: 0, // 上次上报时间
      isLiveStart: false,
      firstReport: false,
      timer: '', //定时器
      playTime: '', //开播时长
      userCount: '', //在线人数
      userCountShow: 0, //在线人数 0不显示 1 显示
      enlarge: require('../../../assets/img/live/full_screen.png'),
      narrow: require('../../../assets/img/live/narrow.png'),
      putAway: require('../../../assets/img/live/putAway.png'),
      open: require('../../../assets/img/live/open.png'),
      iconStatus: false, //false 默认展开  true 收起
      livePlayerShow: true, // livePlayer 默认显示 false 不显示
      coordinate: {
        //坐标
        client: {},
        elePosition: {},
      },
      showLiveSet:false
    };
  },
  components: { Lottry, Sign, Answer,LiveSet },
  async created() {},
  mounted() {
    this.liveData = this.$route.query;
    this.liveData.buyRecord = this.buyInfo.id;
    this.isLiveStart = false;
    window.clearInterval(this.uploadTimer);
    this.initLive();

  },
  methods: {
    // 初始化播放器
    async initLive() {
      // eslint-disable-next-line no-undef
      DWLive.init(this.initData);
      // eslint-disable-next-line no-undef
      DWLive.onLoginError = (data) => {}; // 鉴权处理
      DWLive.onLoginSuccess = (data) => {
        this.loginSuccess(data);
      };
      // eslint-disable-next-line no-undef

      DWLive.onLiveTime = (data) => {
        clearInterval(this.timer);
        if (data.liveDuration !== -1) {
          //直播已开始
          this.timer = setInterval(() => {
            let diff = moment(new Date()).diff(
              moment(new Date(data.liveStartTime.replace(/-/g, '/'))),
            );
            let time = timerCount(diff, 2);
            this.playTime = `${time.h == '00' ? '' : time.h + ':'}${time.m}:${time.s}`;
            if (navigator.onLine) {
              this.onLine = true;
            } else {
              this.onLine = false;
            }
          }, 1000);
        }
      }; //获取直播时间
      (DWLive.onUserCountMessage = (data) => {
        this.userCount = data;
      }), //在线人数
        (DWLive.showUserCount = (data) => {
          this.userCountShow = data;
        }),
        // 获取当前播放（数据源）场景 (摄像头等)
        (DWLive.onSwitchSource = (data) => {
          this.source_type = JSON.parse(data).source_type;
          this.livePlayerShow = this.source_type !== '11';
          this.teacherShow();
        }),
        //  直播间布局配置  是否开启摄像头
        (DWLive.onRoomSetting = (data) => {
          this.source_type = data.source_type;
          this.livePlayerShow = this.source_type !== '11';
          this.teacherShow();
        });
      DWLive.onLiveStarting = () => {
        console.log('我开始直播了')
        this.$parent.checkLiveStatus(1);
        // this.isLiveStart = true
        // this.studyStartTime = moment()
        // this.studyTime = 0
        // this.lastReportTime = 0
        // this.reportTime = 0
        // this.firstReport = true
        // window.clearInterval(this.uploadTimer)
        // this.sendUploadStudyProgressFun(this.liveData, 1)

        this.liveStatus = 1;
        this.controlShow = true;
        this.videoControl();
        this.videoPlay();
        this.controlTimer = setTimeout(() => {
          this.controlShow = false;
        }, 8000);
      }; // 直播中
      // eslint-disable-next-line no-undef
      DWLive.onLiveStart = () => {
        console.log('开始直播');
        this.teacherShow();
      }; // 开始直播
      DWLive.onLiveEnd = () => {
        console.log('我结束直播了 ');
        this.livePlayerShow = false;
        this.liveStatus = 2;
        this.$emit('isShowTeacher', true);
        this.stopLive();
      }; // 停止直播
    },
    loginSuccess(data) {
      console.log(data, 44444);
      const { liveDuration } = data.live; // liveDuration 直播持续时长，通过改字段判断是否
      if (liveDuration <= 0) {
        this.$parent.checkLiveStatus(0);
      }
    },
    teacherShow() {
      if (!this.livePlayerShow) {
        this.$emit('isShowTeacher', true);
      } else {
        this.$emit('isShowTeacher', false);
      }
    },
    videoControl() {
      let controlTime = () => {
        this.controlShow = true;
        const myVideo = document.getElementById('player_live');
        this.videoPlaying = !myVideo?.paused;
        if (this.controlTimer) {
          clearTimeout(this.controlTimer);
        }
        this.controlTimer = setTimeout(() => {
          this.controlShow = false;
        }, 5000);
      };
      document.getElementById('player_live').controls = false;
      document.getElementsByClassName('video-control')[0].addEventListener(
        'click',
        () => {
          // if(this.liveStatus === 1){
          controlTime();
          // }
        },
        false,
      );
      this.$nextTick(() => {
        // 刷新播放状态
        const myVideo = document.getElementById('player_live');
        this.videoPlaying = !myVideo?.paused;
        // 监听全屏
        myVideo.addEventListener('webkitendfullscreen', () => {
          this.videoPlaying = !myVideo.paused;
        });
      });
    },
    changeChatNoticeStatus() {
      //全屏时 收起展开聊天 公告
      this.iconStatus = !this.iconStatus;
      this.$emit('changeChatNoticeStatus');
    },
    recommendShow() {
      this.$emit('recommendShow');
    },
    // 播放，暂停
    playPause() {
      const myVideo = document.getElementById('player_live');
      if (myVideo.paused) {
        myVideo?.play();
        this.videoPlaying = true;
      } else {
        // myVideo.pause();
        // this.videoPlaying = false;
      }
    },

    videoPlay() {
      setTimeout(() => {
        const myVideo = document.getElementById('player_live');
        myVideo?.play().then(() => {
          this.videoPlaying = true;
        });
      }, 1000);
    },

    fullScreenClick() {
      if (this.fullscreenVal) {
        this.fullscreenVal = false;
        this.$emit('changeScreenStatus');
      } else {
        this.fullscreenVal = true;
        this.$emit('changeScreenStatus');
      }

      if (this.iconStatus) {
        //如果是收起状态的 需要给显示出来
        this.changeChatNoticeStatus();
      }
    },

    back() {
      if (this.fullscreenVal) {
        this.fullScreenClick();
      } else {
        this.$router.back();
        clearInterval(this.timer);
      }
    },

    // 上传学习进度
    async sendUploadStudyProgressFun(liveData, isDrag) {
      if (!this.firstReport && isDrag === 1) {
        return;
      }
      window.clearInterval(this.uploadTimer);
      this.lastReportTime = moment();
      if (isDrag !== 3) {
        // isDrag === 3 上报结束的情况下不重启定时器
        this.uploadTimer = setInterval(() => {
          const nowTime = moment();
          this.reportTime = nowTime.diff(this.lastReportTime, 'seconds');
          this.studyTime = nowTime.diff(this.studyStartTime, 'seconds');
          this.sendUploadStudyProgressFun(liveData, 0);
        }, 300000);
      }

      let { chapterId, liveId, buyRecord, courseId } = liveData;
      let { id } = this.userInfo;
      let data = {
        userId: id,
        productId: courseId,
        productSkuId: this.buyInfo.skuId,
        userProductId: this.buyInfo.id,
        curriculumId: this.buyInfo.productCurriculumId,
        chapterId: this.$route.query.chapterId,
        chapterName: this.$route.query.liveName,
        sourceType: 2,
        position: 0,
        reportTime: this.reportTime,
        learnProgress: 0,
        isDrag,
        source: 5,
        ua: window.navigator.userAgent,
        updateTime: this.$root.getLocalTime(),
      };
      // console.log(data,'我是保存的学习进度')
      const res = await sendUploadStudyProgress(data);
      if (res.code === 0) {
        // console.log("学习进度保存成功");
        this.firstReport = false;
      } else {
        window.clearInterval(this.uploadTimer);
      }
    },

    stopLive(val) {
      if (val === 'stop') {
        DWLive.destroy();
      }
      if (!this.isLiveStart) {
        return;
      }
      if (this.lastReportTime === 0 || this.studyStartTime === 0) {
        return;
      }
      // console.log('停止直播，并清楚了直播间')
      window.clearInterval(this.uploadTimer);
      this.liveStatus = 2;
      const nowTime = moment();
      this.reportTime = nowTime.diff(this.lastReportTime, 'seconds');
      this.studyTime = nowTime.diff(this.studyStartTime, 'seconds');
      this.sendUploadStudyProgressFun(this.liveData, 3);
      this.isLiveStart = false;
      document.getElementById('livePlayer').innerHTML = '';
      document.getElementById('livePlayer').style.lineHeight = 0;
    },
    touchstartHandle(refName, e) {
      if (this.fullscreenVal) return;
      let element = e.targetTouches[0];
      // 记录点击的坐标
      this.coordinate.client = {
        x: element.clientX,
        y: element.clientY,
      };
      // 记录需要移动的元素坐标
      this.coordinate.elePosition.left = this.$refs[refName].offsetLeft;
      this.coordinate.elePosition.top = this.$refs[refName].offsetTop;
    },
    touchmoveHandle(refName, e) {
      if (this.fullscreenVal) return;
      let element = e.targetTouches[0];
      // 根据初始 client 位置计算移动距离(元素移动位置=元素初始位置+光标移动后的位置-光标点击时的初始位置)
      let x = this.coordinate.elePosition.left + (element.clientX - this.coordinate.client.x);
      let y = this.coordinate.elePosition.top + (element.clientY - this.coordinate.client.y);
      // 限制可移动距离，不超出可视区域
      x =
        x <= 0
          ? 0
          : x >= innerWidth - this.$refs[refName].offsetWidth
          ? innerWidth - this.$refs[refName].offsetWidth
          : x;
      y =
        y <= 0
          ? 0
          : y >= innerHeight - this.$refs[refName].offsetHeight
          ? innerHeight - this.$refs[refName].offsetHeight
          : y;
      // 移动当前元素
      this.$refs[refName].style.left = x + 'px';
      this.$refs[refName].style.top = y + 'px';
      // this.$refs[refName].style.bottom = 'auto'
      // this.$refs[refName].style.right = 'auto'

      e.preventDefault(); // 阻止屏幕滚动的默认行为
    },
    openLiveSet() {
      console.log(2222)
      this.showLiveSet = true;
    },
    closeLiveSet() {
      this.showLiveSet = false;
    },
  },
};
</script>
<style lang="scss">
.file-player-component {
  position: relative;
  height: calc(100vw * 0.5625);
  background: black;
  #drawPanel {
    width: 100%;
    background: #fff;
  }
  .overLive {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 22px;
    background: rgba(0, 0, 0, 0.7);
  }
  #livePlayer {
    position: fixed;
    top: calc(100vw * 0.94);
    right: 0;
    z-index: 10;
    width: 100px;
    height: 80px;
    overflow: hidden;
    background: #ccc;
  }
  .video-control {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    color: white;
    .control-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: linear-gradient(rgba(119, 96, 96, 0.7), rgba(0, 0, 0, 0));
      .left{
        display: flex;
        align-items: center;
      }
      .right{
        padding-right: 41px;
        .set{
          width: 22px;
          height: 22px;
          background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/live/live-set.png');
          background-size: 100%;
        }
      }
      .live-title {
        width: 250px;
        overflow: hidden;
        color: white;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .control-icon {
        margin-right: 0;
      }
    }

    .control-bottom {
      z-index: 1;
      display: flex;
      height: 60px;
      padding-left: 10px;
      // justify-content: space-between;
      background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7));
      .control-bottom-left {
        display: flex;
        align-items: center;
        font-size: 16px;
        .userCount {
          margin-left: 15px;
        }
      }
      .control-bottom-right {
        display: flex;
        align-items: center;
        margin-left: auto;
        font-size: 16px;
        span {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          margin: 0 15px;
        }
        img {
          width: 30px;
          height: 30px;
          margin: 0 10px;
        }
      }
    }
  }

  .control-icon {
    width: 30px;
    height: 30px;
    margin: 15px;
  }
}
.is-full-screen {
  height: 100vw;
  padding-bottom: 0;
  #drawPanel {
    width: 75% !important;
  }
  #drawPanel.fullDrawPanel {
    width: 100% !important;
  }
  .overLive {
    width: 75% !important;
  }
  #livePlayer {
    position: absolute;
    top: 0 !important;
    right: 0 !important;
    left: initial !important;
    width: 25%;
    height: calc(100vw * 0.27);
  }
  .fullScreenChat {
    position: fixed;
    top: calc(100vw * 0.27);
    right: 0;
    width: 25%;
    height: calc(100vw * 0.73);
  }
}
.fullscreen {
  #player_live {
    width: 100%;
    max-height: 100vh;
  }
}
</style>
